module.exports = __webpack_public_path__ + "static/media/main--background.8ca320f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/main/main--background.jpg
// module id = 191
// module chunks = 0